export default [
  {
    route: 'users',
    title: 'users',
    icon: 'UserIcon',
    i18n: 'Users',
    rule: 'users.menu'
  },
  {
    route: 'roles',
    title: 'roles',
    icon: 'UsersIcon',
    i18n: 'Roles',
    rule: 'roles.menu'
  },
  {
    route: null,
    title: 'people',
    icon: 'UsersIcon',
    i18n: 'People',
    rule: 'people.menu',
    children: [
      {
        route: '/people/natural-entities',
        name: 'people-natural-entities',
        title: 'naturalEntity',
        i18n: 'NaturalEntity',
        rule: 'people.natural_entity.menu'
      },
      {
        route: '/people/legal-entities',
        name: 'people-legal-entities',
        title: 'legalEntity',
        i18n: 'LegalEntity',
        rule: 'people.legal_entity.menu'
      },
      {
        route: 'privacy-form',
        title: 'privacyFormTitle',
        icon: 'CheckSquareIcon',
        i18n: 'privacyFormTitle',
        rule: 'privacy_form.menu'
      },
      {
        route: 'incident-form',
        title: 'incidentFormTitle',
        icon: 'CheckSquareIcon',
        i18n: 'incidentFormTitle',
        rule: 'incident_form.menu'
      },
    ]
  }
]
